/**
 * @Description 页面居中的Spin
 */
import { FC } from 'react';
import { Spin } from 'antd';
// import cs from 'classnames';
import styles from './index.module.less';

const CenterSpin: FC<any> = () => {

  return (
    <div className={styles.centerSpinCon}>
      <Spin/>
    </div>
  );
};

export default CenterSpin;
